import { create } from "zustand";
import { deleteTag, getBookingData, getNextEngagement, oralMinox, setChatData, setOrderType, setTag } from "../api";
import { CNX_ENGAGEMENT, MEDREP_ENG_ACCESS, QUAS_ENGAGEMENT, TOAST_MESSAGE_CSS, currentUser, engagementDateFilter, engagementFilter, getCurrentUserRole } from "modules/utilities/utility";
import { toast } from 'react-toastify';
import { get } from "lodash";

export const useBookingData = create((set) => ({
  orderData: [],
  sortedEngagementFirstElemId: null,
  isLoading: false,
  isError: false,
  fetchBookingData: async (id, setData, setBooking) => {
    set({ isLoading: true, orderData: [] });
    setData && setData([]);
    setBooking && setBooking([]);
    try {
      const response = await getBookingData(id);
      set({ orderData: response.data });
      if (QUAS_ENGAGEMENT.includes(getCurrentUserRole())) {
        setData && editSetBooking(engagementFilter(response.data, ["Week #3", "retention"]));
      } else if (CNX_ENGAGEMENT.includes(getCurrentUserRole())) {
        setData && editSetBooking(engagementFilter(response.data, ["retention", "Week #3"]));
      } else if (MEDREP_ENG_ACCESS.includes(currentUser)) {
        setData && editSetBooking(engagementDateFilter(response.data));
      } else {
        setData && editSetBooking(response.data);
      }
      setBooking && editSetBooking(response.data);
      function editSetBooking (engagements){

        const sortedEngagements = engagements.sort((engagementA, engagementB)=> new Date(engagementA.reminder_date) - new Date(engagementB.reminder_date))
        setData(sortedEngagements);
        set({ sortedEngagementFirstElemId: get(sortedEngagements, ['0', '_id'], null)});
      }
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const useSetChat = create((set) => ({
  data: {},
  isLoading: false,
  isError: false,
  setChatMessage: async (id, message, fetchFreshChatData) => {
    toast.info(`Sending Message`,TOAST_MESSAGE_CSS);
    set({ isLoading: true });
    try {
      const response = await setChatData(id, message);
      set({ data: response.data });
      toast.success(`Message sent`, TOAST_MESSAGE_CSS);
      fetchFreshChatData(id);
    } catch (error) {
      set({ isError: true, data: [] });
      toast.error(`Failed to send message `, TOAST_MESSAGE_CSS);
    } finally {
      set({ isLoading: false });
    }
  },
}));
//

export const useSetTag = create((set) => ({
  setTagData: {},
  isLoading: false,
  isError: false,
  setTagToCase: async (id, tag_id) => {
    set({ isLoading: true });
    try {
      const response = await setTag(id, tag_id);
      set({ data: response.data });
      return response.data;
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const useDeleteTag = create((set) => ({
  deleteTagData: {},
  isLoading: false,
  isError: false,
  deleteTagFromCase: async (id, tag_id) => {
    set({ isLoading: true });
    try {
      const response = await deleteTag(id, tag_id);
      set({ data: response.data });
      return response.data;
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const useSetOrderType = create((set) => ({
  data: {},
  isLoading: false,
  isError: false,
  setOrderTypeForCase: async (id, requestObject) => {
    set({ isLoading: true });
    try {
      const response = await setOrderType(id, requestObject);
      set({ data: response.data });
      return response.data;
    } catch (error) {
      set({ isError: true, data: [] });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const useNextEngagement = create((set) => ({
  nextEngagementData: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  nextEngagements: async () => {
    set({ nextEngagementData: {} });
    set({ isLoading: true, nextEngagementData: {} });
    try {
      const response = await getNextEngagement();
      set({ nextEngagementData: response.data, isLoading: false });
    } catch (error) {
      set({
        isError: true,
        errorMessage: error?.response?.data?.message,
        isLoading: false,
      });
    }
  },
}));

export const useOralMinox = create((set) => ({
  oralMinoxData: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  fetchOralMinox: async (caseId) => {
    set({ isLoading: true, isError:null });
    try {
      const response = await oralMinox(caseId);
      set({ oralMinoxData: response.data, isLoading: false });
    } catch (error) {
      set({
        isError: true,
        errorMessage: error?.response?.data?.message,
        isLoading: false,
      });
    }
  },
}));
